import { combineReducers } from 'redux';

import MyPATIconButton from './MyPATIconButton';
import MyPATDialog from './MyPATDialog';
import MyPATMultiSearch from './MyPATMultiSearch';
import MyPATSearchBar from './MyPATSearchBar';
import MyPATDateRange from './MyPATDateRange';
import MyPATTextField from './MyPATTextField';
import MyPATToaster from './MyPATToaster';
import MyPATSelect from './MyPATSelect';
import MyPATDropdown from './MyPATDropdown';
import MyPATTextArea from './MyPATTextArea';
import MyPATLink, { MyPATRouterLink } from './MyPATLink';
import SearchField from './SearchField';
import TagPreview from './TagPreview';
import MyPATPopMenu from './MyPATPopMenu';
import MenuData from './MenuData';
import MyPATProfileBox from './MyPATProfileBox';
import MyPATCollapse from './MyPATCollapse';
import MyPATExpansionPanel from './MyPATExpansionPanel';
import MyPATSnackbar from './MyPATSnackbar';
import MyPATSnackbarV2 from './MyPATSnackbarV2';
import MyPATLocalLoader from './MyPATLocalLoader';
import MyPATGlobalLoader from './MyPATGlobalLoader';
import MyPATFileUpload from './MyPATFileUpload';
import MyPATFileUploadTab from './MyPATFileUploadTab';
import MyPATAudioUpload from './MyPATAudioUpload';
import MyPatSliderProgress from './MyPatSliderProgress';
import MyPatUploadProgress from './MyPatUploadProgress';
import MyPatVideoPlayer from './MyPatVideoPlayer';
import TimePicker from './TimePicker';
import MyPATMultiSelect from './MyPATMultiSelect';
// math html editor and field components
import MyPATMathField from './MyPATMathField';
import MyPATMathEditor from './MyPATMathEditor';

import ModalComponent from './ModalComponent';
import AwardGraceMarks from './AwardGraceMarks';
import RePublishQueue from './RePublishQueue';

//services
import dateService from './services/dateService';

//import and merge all reducers
import serverAlertReducer from './reducers/serverAlertReducer';
import loaderReducer from './reducers/loaderReducer';
import postLicenseExpiryReducer from "./reducers/postLicenseExpiryReducer";

//import all data types
import { UserData, RoleData } from './types/UserData';
import { LoaderAction } from './types/LoaderAction';
import { ServerAlertAction } from './types/ServerAlertAction';
import focusedSectionReducer from './reducers/focusedSection';

const reducers = combineReducers({
    serverAlert: serverAlertReducer,
    showLoader: loaderReducer,
    postLicenseExpiry: postLicenseExpiryReducer,
    focusedSection: focusedSectionReducer
});


export {
    MyPATIconButton,
    MyPATDialog,
    MyPATSearchBar,
    MyPATMultiSearch,
    MyPATDateRange,
    MyPATTextField,
    MyPATToaster,
    MyPATSelect,
    MyPATDropdown,
    MyPATTextArea,
    MyPATLink,
    MyPATRouterLink,
    SearchField,
    TagPreview,
    MyPATPopMenu,
    MenuData,
    MyPATProfileBox,
    MyPATCollapse,
    MyPATExpansionPanel,
    MyPATSnackbar,
    MyPATSnackbarV2,
    MyPATLocalLoader,
    MyPATGlobalLoader,
    MyPATMathField,
    MyPATFileUpload,
    MyPATFileUploadTab,
    MyPATAudioUpload,
    MyPatUploadProgress,
    MyPatVideoPlayer,
    MyPatSliderProgress,
    MyPATMathEditor,
    ModalComponent,
    AwardGraceMarks,
    RePublishQueue,
    reducers,
    UserData,
    RoleData,
    LoaderAction,
    ServerAlertAction,
    TimePicker,
    dateService,
    MyPATMultiSelect
};